/** This is a replacement for the toFixed() method that doesn't round the value */
export const truncateToDecimals = (value: number, decimalPlaces = 2) => {
  const decimals = Math.pow(10, decimalPlaces);
  return Math.trunc(value * decimals) / decimals;
};
